import moment from 'moment';

moment.locale('us');

const childDataSet1 = {
  columns: [
    {
      prop: 'dataA',
      label: 'Data A',
      width: 200,
    },
    {
      prop: 'dataB',
      label: 'Data B',
      width: 100,
    },
    {
      prop: 'dataC',
      label: 'Data C',
      width: 100,
    },
  ],
  data: {
    columnKey: 'childDataSet1',
    data: [
      {
        dataA: 'Einzzzzzzz',
        dataB: '1',
        dataC: 'One',
      },
      {
        dataA: 'Zweiiiiii',
        dataB: '2',
        dataC: 'Two',
      },
    ],
  },
};
export const productTypes = [
  'Basic Life / AD&D',
  'Basic Dependent Life',
  'Voluntary Life',
  'Voluntary AD&D',
  'Short Term Disability',
  'ASO STD',
  'NY DBL',
  'NJ TDB',
  'HI TDI',
  'Absence Management',
  'Dental',
  'Long Term Disability',
  'Vision',
  'Accident',
  'Hospital Indemnity',
  'Stop Loss',
  'Voluntary Life / AD&D',
  'Critical Illness',
];

const getNumber = (max) => Math.floor(Math.random() * (max - 0) + 0);
const randomDate = () => {
  const startDate = new Date(2020, 0, 1).getTime();
  const endDate = new Date(2021, 11, 30).getTime();
  const spaces = (endDate - startDate);
  let timestamp = Math.round(Math.random() * spaces);
  timestamp += startDate;

  return getNumber(50) > 40
    ? ''
    : moment(timestamp).format('YYYY-MM-DD');
};
const createBrokerRow = (id) => {
  const brokers = [
    'Confie',
    'NFP',
    'Risk Strategies',
    'Leavitt Group',
    'Insurance Office of America Inc.',
    'IMA Financial Group Inc.',
    'Alera Group',
    'Higginbotham',
    'Cross Insurance',
    'Hilb Group',
    'Heffernan Insurance Brokers',
    'HQ',
    'PayneWest Insurance Inc.',
    'AIS Insurance*',
    'Hylant',
    'INSURICA Inc.',
    'Baldwin Risk Partners',
    'UniVista Insurance',
    'TWFG Insurance Services',
    'Westwood Insurance Agency*',
    'Propel Insurance',
    'Eastern Insurance Group LLC**',
    'TrueNorth',
    'Marshall & Sterling Enterprises Inc.',
    'PCF Insurance Services LLC',
    'Towne Insurance**',
    'Relation Insurance Services',
    'Lawley Insurance',
    'Starkweather & Shepley Insurance Brokerage Inc.',
    'Professional Insurance Associates',
    'Graham Company',
    'Parker, Smith & Feek Inc.',
    'World Insurance Associates LLC',
    'Shepherd Insurance',
    'Houchens Insurance Group Inc.',
    'M&T Insurance Agency Inc.**',
    'Haylor, Freyer & Coon Inc.',
    'Frost Insurance**',
    'Rich & Cartmill Inc.',
    'Bolton & Company',
    'Insgroup Inc.',
    'Moreton & Company',
    'Wood Gutmann & Bogart Insurance Brokers',
    'Turner Surety & Insurance Brokerage (TSIB)',
    'People’s United Insurance Agency Inc.**',
    'James G Parker Insurance Associates',
    'The Buckner Company Inc.',
    'AHT Insurance',
    'R&R Insurance Services',
    'Atlas Insurance Brokers LLC',
    'JGS Insurance',
    '',
  ];

  return {
    activeDate: randomDate(),
    brokerName: brokers[getNumber(brokers.length)],
    productTypes: [productTypes[getNumber(productTypes.length)],
      productTypes[getNumber(productTypes.length)]],
    dueDate: randomDate(),
    easterEgg: ['rock', 'paper', 'scissors'][Math.floor(Math.random() * 3)],
    effectiveDate: randomDate(),
    employeeCount: getNumber(2000),
    id: id + 1,
  };
};
const createProjectRow = (id) => {
  const editors = [
    'Joel',
    'Jane',
    'GLaDOS',
    '',
  ];
  const carriers = [
    'MetLife',
    'Sun Life',
    'Aetna',
  ];
  const children = [
    childDataSet1.data,
    {
      columnKey: 'childDataSet2',
      data: [
        {
          dataD: 'Lorem',
          dataE: 'Ipsum',
        },
        {
          dataD: 'Set',
          dataE: 'Dolor',
        },
      ],
    },
  ];
  const { orderStatus, status } = [
    { orderStatus: 1, status: 'New Policy Sold' },
    { orderStatus: 2, status: 'Renewed' },
    { orderStatus: 3, status: 'Policy Audit' },
  ][getNumber(3)];
  const projects = [
    'Spacely Sprockets',
    'Gizmonics',
    'Aperture Science',
    '',
  ];

  return {
    children: getNumber(50) > 40 ? children : null,
    id: id + 1,
    lastEditor: editors[getNumber(editors.length)],
    name: projects[getNumber(projects.length)],
    orderStatus,
    soldCarrier: carriers[getNumber(carriers.length)],
    status,
  };
};

export const table3 = {
  meta: {
    columns: [
      {
        prop: 'name',
        label: 'Project Name',
        sortable: true,
      },
      {
        prop: 'soldCarrier',
        label: 'Sold Carrier',
        sortable: true,
      },
      {
        prop: 'lastEditor',
        label: 'Last Editor',
        sortable: true,
      },
      {
        prop: 'status',
        label: 'Status',
        width: 150,
        sortable: 'orderStatus',
      },
    ],
    childColumns: {
      childDataSet1: childDataSet1.columns,
      childDataSet2: [
        {
          prop: 'dataD',
          label: 'Data D',
          width: 200,
        },
        {
          prop: 'dataE',
          label: 'Data E',
          width: 100,
        },
      ],
    },
    sort: {
      prop: 'soldCarrier',
      direction: 'desc',
    },
  },
  data: [...Array(120).keys()].map((id) => createProjectRow(id)),
};

export const tableWithTargetedSort = {
  data: [
    {
      name: 'Crow',
      status: 'Completed',
      orderStatus: 3,
    },
    {
      name: 'Servo',
      status: 'In Progress',
      orderStatus: 2,
    },
    {
      name: 'Mike',
      status: 'Not Started',
      orderStatus: 1,
    },
    {
      name: 'Larry',
      status: 'In Progress',
      orderStatus: 2,
    },
    {
      name: 'Mo',
      status: 'Completed',
      orderStatus: 3,
    },
    {
      name: 'Steeeeeeeve',
      status: 'Not Started',
      orderStatus: 1,
    },
    {
      name: 'God',
      status: 'Infinite...',
      orderStatus: 100,
    },
  ],
  meta: {
    columns: [
      {
        prop: 'name',
        label: 'Name',
        sortable: true,
      },
      {
        prop: 'status',
        label: 'Status',
        sortable: 'orderStatus',
      },
    ],
    sort: {
      prop: 'status',
      direction: 'asc',
    },
  },
};

export const tableWithPagination = {
  data: [...Array(100).keys()].map((id) => createBrokerRow(id)),
  meta: {
    columns: [
      {
        prop: 'brokerName',
        label: 'Broker Name',
        sortable: true,
        width: 175,
      },
      {
        prop: 'activeDate',
        label: 'Active Date',
        sortable: true,
      },
      {
        prop: 'effectiveDate',
        label: 'Effective Date',
        sortable: true,
      },
      {
        prop: 'productTypes',
        label: 'Product Types',
        sortable: false,
      },
      {
        prop: 'dueDate',
        label: 'Due Date',
        sortable: true,
      },
      {
        prop: 'employeeCount',
        label: 'Employee Count',
        sortable: true,
        width: 140,
      },
    ],
    sort: {
      prop: 'effectiveDate',
      direction: 'asc',
    },
  },
};
